<template>
  <van-popup
    v-model="showPop"
    position="bottom"
    round
  >
    <img
      src="@/assets/img/warn.png"
    />
    <div class="popup-title">
      请确认分润信息
    </div>

    <div class="popup-content">
      <div style="color:#666;">
        有分润信息需确认，请去确认
      </div>
    </div>
    <div class="bottom-btns">
      <van-button
        type="default"
        class="close-btn"
        @click="close"
      >
        稍后确认
      </van-button>
      <van-button
        type="primary"
        class="confirm-btn"
        @click="toSign"
      >
        去确认
      </van-button>
    </div>
  </van-popup>
</template>

<script>
import { SERVICE_LEVEL_EXPLAIN_LIST } from '@/constants/serviceLevel';


export default {
  name: 'NotSignPop',
  props: {
    showPop: {
      type: Boolean,
      default: false,
      required: true,
    },
    close: {
      type: Function,
      default: () => {},
      required: true,
    },
    toSign: {
      type: Function,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      isShowTip: false,
      SERVICE_LEVEL_EXPLAIN_LIST,
      tip: {},
    };
  },
};
</script>

<style lang="scss" scoped>
.van-popup {
  text-align: left;
  display: flex;
  // justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  .popup-title {
    font-size: 4.267vw;
    font-weight: bold;
    line-height: 4.267vw;
    text-align: center;
    margin: 40px 0 32px 0;
  }
  img {
    width: 90px;
    height: 90px;
    display: block;
    // position: absolute;
    top: 4.533vw;
    right: 4vw
  }
  .popup-content {
    font-weight: 400;
    color: #999999;
    font-family: PingFang SC;
    font-size: 28px;
    line-height: 28px;
    text-align: center;
  }
  .bottom-btns {
    margin: 56px 0 40px;
    width: 100%;
    display: flex;
    padding: 24px;
    background: #FFF;
    .van-button {
      border-radius: 0.12rem;
      font-weight: 500;
      color: #222222;
      &.close-btn{
        background: #fff;
      }
      &.confirm-btn{
        background: #FFD100;
        border-color: #FFD100;
      }
      flex: 1;
      &:first-child {
        margin-right: 24px;
      }
    }
  }
}
</style>
